import { render } from "./ResponsibleProducerUpdate.vue?vue&type=template&id=2e138795"
import script from "./ResponsibleProducerUpdate.vue?vue&type=script&lang=js"
export * from "./ResponsibleProducerUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__